import React from "react";
import DateDisplay from "../../../components/DateDisplay";
import ProfileDisplay from "../../../components/ProfileDisplay";
import GraphSubscriptionTableRowActionColumn from "./GraphSubscriptionTableRowActionColumn";
import GraphSubscriptionTableRowColumn from "./GraphSubscriptionTableRowColumn";
import { ThemedSpan } from "../../../components/utilities";
import { TableLoadingRow } from "../../../components/tables/VirtualTable";
import { type GraphSubscriptionType } from "../../../types/GraphSubscriptionType";

export type GraphSubscriptionTableRowProps = {
    data: GraphSubscriptionType[]
    dateFormat?: string
    index: number
    style?: any
};

const GraphSubscriptionTableRow = ({ data, dateFormat = "DD/MM/YYYY HH:mm", index, style } : Readonly<GraphSubscriptionTableRowProps>) => {
    const { height } = style;

    if (index >= data.length) {
        return <TableLoadingRow style={{ height }} />
    }

    const {
        userId,
        description,
        typeDescription,
        changeType,
        notificationUrl,
        createdDate,
        createdById,
        expirationDate
    } = data[index];

    return (
        <tr>
            <GraphSubscriptionTableRowColumn width={12}>
                <ProfileDisplay userId={userId} />
            </GraphSubscriptionTableRowColumn>
            <GraphSubscriptionTableRowColumn width={14}>
                <p className="text-truncate m-0 lh-1">
                    {typeDescription}
                    <br/>
                    <ThemedSpan variant="muted" className="fs-smallest">{description ?? "-"}</ThemedSpan>
                </p>
            </GraphSubscriptionTableRowColumn>
            <GraphSubscriptionTableRowColumn width={7}>
                <p className="text-truncate m-0">
                    {changeType}
                </p>
            </GraphSubscriptionTableRowColumn>
            <GraphSubscriptionTableRowColumn>
                <p className="text-truncate m-0">
                    {notificationUrl}
                </p>
            </GraphSubscriptionTableRowColumn>
            <GraphSubscriptionTableRowColumn width={12}>
                {expirationDate ?
                    <DateDisplay className="font-monospace" format={dateFormat}>{expirationDate}</DateDisplay>
                    : <span className="font-monospace">-</span>
                }
            </GraphSubscriptionTableRowColumn>
            <GraphSubscriptionTableRowColumn width={12}>
                <DateDisplay className="font-monospace" format={dateFormat}>{createdDate}</DateDisplay>
            </GraphSubscriptionTableRowColumn>
            <GraphSubscriptionTableRowColumn width={12}>
                <ProfileDisplay userId={createdById} />
            </GraphSubscriptionTableRowColumn>
            <GraphSubscriptionTableRowColumn width={2.5}>
                <GraphSubscriptionTableRowActionColumn data={data[index]} />
            </GraphSubscriptionTableRowColumn>
        </tr>
    );
};

export default GraphSubscriptionTableRow;